import React from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useApolloClient } from "react-apollo";
import gql from "graphql-tag";

import { printDirections } from "../../utils/export";
import { ourToast as toast } from "../../utils";

const SINGLE_DIRECTION_QUERY = gql`
  query SINGLE_DIRECTION_QUERY($where: DirectionWhereUniqueInput) {
    Direction(where: $where) {
      RecId
      Priority
      Directions
      LoadedMiles
      SpecInstr
      OriginLocation {
        RecId
        LocationID
        LocationName
        City
        State
      }
      DestinationLocation {
        RecId
        LocationID
        LocationName
        City
        State
      }
    }
  }
`;

const PrintDirectionButton = ({ RecId }) => {
  const client = useApolloClient();
  const handlePrint = async () => {
    try {
      const { data: DirectionData } = await client.query({
        query: SINGLE_DIRECTION_QUERY,
        variables: {
          where: {
            RecId
          }
        }
      });
      printDirections(DirectionData.Direction);
    } catch (err) {
      toast.error(`Error printing directions`);
      console.log(err);
    }
  };
  return (
    <div>
      <Button color="primary" role="button" type="button" onClick={handlePrint}>
        <Icon>
          <FontAwesomeIcon icon="print" />
        </Icon>
      </Button>
    </div>
  );
};

PrintDirectionButton.propTypes = {
  RecId: PropTypes.number
};

export default PrintDirectionButton;
